// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-form .btn-block[data-v-04287dbc]{align-items:center;display:flex;margin-bottom:15px}.login-form .form-container[data-v-04287dbc]{align-items:stretch;flex-direction:column}.login-form a.dashed[data-v-04287dbc]{color:#3b3b3b;font-weight:lighter;-webkit-text-decoration:underline;text-decoration:underline;text-decoration-style:dashed}.login-form .form-field[data-v-04287dbc] .header{display:flex;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
